import React from 'react';

/** Preserve the transparent brand asset and its green mark on dark surfaces. */
export function BrandThemeFilters() {
  return (
    <svg aria-hidden="true" focusable="false" width="0" height="0" style={{ position: 'absolute', pointerEvents: 'none' }}>
      <defs>
        <filter id="vo2-brand-on-dark" colorInterpolationFilters="sRGB" x="0" y="0" width="100%" height="100%">
          <feColorMatrix in="SourceGraphic" type="luminanceToAlpha" result="luminance" />
          <feComponentTransfer in="luminance" result="darkPixels">
            <feFuncA type="discrete" tableValues="1 1 0 0" />
          </feComponentTransfer>
          <feComposite in="darkPixels" in2="SourceAlpha" operator="in" result="wordmarkMask" />
          <feFlood floodColor="var(--palette-paper)" result="wordmarkColor" />
          <feComposite in="wordmarkColor" in2="wordmarkMask" operator="in" result="lightWordmark" />
          <feMerge><feMergeNode in="SourceGraphic" /><feMergeNode in="lightWordmark" /></feMerge>
        </filter>
      </defs>
    </svg>
  );
}
